
var navClasses = {
    openClass: "nav-open",
    activeItemClass: "active-item",
    dropdownOpenClass: "nav__dropdown--open"
};

function openNav($item) {
    $("body").addClass(navClasses.openClass);
    $item.addClass(navClasses.activeItemClass).siblings().removeClass(navClasses.activeItemClass);
}

function closeNav() {
    $("body").removeClass(navClasses.openClass);
    $("." + navClasses.activeItemClass).removeClass(navClasses.activeItemClass);
}

function navigation() {
    var $container = $("#nav");

    if ($container.length > 0) {
        var $trigger = $container.find("#nav__trigger");
        var $closeTrigger = $(".nav-close-trigger");
        var $expandableItemLink = $container.find(".nav__item.expandable > a");

        //Mobile nav trigger
        $trigger.on("click", function () {
            $("body").toggleClass("nav-active");
        });

        //Close menu dropdown trigger
        $closeTrigger.on("click", function () {
            closeNav();
        });

        //Click on expandable items
        $expandableItemLink.on("click", function (e) {

            //If trigger is hidden - it means that we show the desktop menu, and then we want the dropdown to show.
         //   if ($trigger.is(":hidden")) {
                e.preventDefault();

                var $self = $(this);
                var $parent = $self.parent();

                if ($parent.hasClass(navClasses.activeItemClass)) {
                    closeNav($parent);

                } else {
                    openNav($parent);
                }
          //  }
        });

        // ******
        // ATM. We use css to set the max-height of the dropdown:: (100vh - header height)
        // ******
        //var dropdownOpenClass = "nav__dropdown--open";
        //function handleDropdown() {
        //    var $activeItem = $("." + navClasses.activeItemClass);
        //    var $activeDropdown = $("." + dropdownOpenClass);

        //    if ($activeDropdown.length) {
        //        //Close active dropdown
        //        $activeDropdown.css("max-height", 0);
        //    }

        //    if ($activeItem.length) {
        //        var $dropdown = $activeItem.find(".nav__dropdown");
        //        var $dropdownContainer = $dropdown.find(".nav__dropdown-container");

        //        //Open the dropdown by changing the max-height
        //        $dropdown.addClass(dropdownOpenClass).css("max-height", $dropdownContainer.outerHeight(true));
        //    }
        //}
    }
}


$(function () {
    navigation();
});